module.exports = __webpack_public_path__ + "static/media/rms.c7560ba7.ico";